import { Box, Button, OutlinedInput, styled } from "@mui/material";
import { brighthiveTheme } from "../theme/theme";

export const PageSetupHolder = styled(Box)`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  position: relative;
  z-index: 1;

  &.dark {
    background-image: linear-gradient(0deg, #fff0dd 0%, #fffcf9 100%);

    .brighthive-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      opacity: 0.6;
      z-index: -1;
    }
  }

  > .MuiContainer-root {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
`;

export const PageSetup = styled(Box)`
  width: 100%;
  background-color: ${brighthiveTheme.palette.common.white};
  // box-shadow: inset 0px -.0625rem 0px ${brighthiveTheme.palette.action
    .disabledBackground};
  box-sizing: border-box;
  border: 0.0625rem solid ${brighthiveTheme.palette.action.disabledBackground};
  border-radius: 0.375rem;
  padding: 20px;
  max-width: 500px;
  .btn {
    margin: 20px 0 0;
    float: right;
  }
`;

export const TrialSetupPage = styled(Box)`
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
`;

export const LeftSide = styled(Box)`
  width: 48%;
  padding: 20px;
  box-sizing: border-box;
  flex: 1;

  input {
    height: 42px !important;
    padding: 11px !important;
  }

  .trial-setup-form {
    background-color: ${brighthiveTheme.palette.common.white};
    border-radius: 0.375rem;
    padding: 20px;
    max-width: 500px;
    margin: 0 auto;
    border: 0.0625rem solid ${brighthiveTheme.palette.action.disabledBackground};

    &.set-password {
      input {
        height: 42px !important;
        padding: 11px 50px 11px 11px !important;
      }
    }
  }
`;

export const RightSide = styled(Box)`
  width: 50%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  > div {
    position: relative;
    z-index: 1;
  }

  img {
    flex: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 0.375rem;
    border: 0.0625rem solid ${brighthiveTheme.palette.action.disabledBackground};
    filter: blur(4px);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const LogArea = styled(Box)`
  svg {
    width: 170px;
    margin: 0 auto;
  }
`;

export const LinkHolder = styled(Box)`
  border-top: 1px solid ${brighthiveTheme.palette.action.disabledBackground};
  padding-top: 20px;
  margin-top: 20px;
  a {
    color: ${brighthiveTheme.palette.link.main};
  }
`;
